import type { SVGProps } from 'react';

const SvgThumbnailBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <rect x={4} y={4.75} width={16} height={10} rx={1} stroke='currentColor' strokeWidth={2} />
    <path d='M4 19.3999H20' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
  </svg>
);
export default SvgThumbnailBd;
